import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/organizations',
    name: RouteName.Organizations,
    component: () => import('@/pages/Organization/OrganizationList'),
    meta: {
      breadcrumb: {
        label: 'Организации',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/organizations/create',
    name: 'organizationCreate',
    component: () => import('@/pages/Organization/OrganizationCreate'),
    meta: {
      breadcrumb: {
        label: 'Новая организации',
        parent: RouteName.Organizations,
      },
    },
  },
  {
    path: '/organizations/:id',
    name: 'organizationEdit',
    component: () => import('@/pages/Organization/OrganizationSingle'),
    props: { isEdit: false },
    meta: {
      breadcrumb: {
        label: 'Редактирование организации',
        parent: RouteName.Organizations,
      },
    },
  },
]
